export default "__VITE_ASSET__DhFC8tXS__"